// Slots the host page can fill.
//
// HostMenuExtras: extra controls shown inside the desk's account menu (the standalone's Light / Dark / System switch).
// HostIdentity:   who is signed in. When a host provides one, the desk takes the role and name from it (the role can no
//                 longer be picked freely, except that an admin may preview the other roles) and the account menu gains
//                 Sign out. Inside the CRM nothing is provided and the desk keeps its role chooser until real roles are
//                 wired to Twenty's workspace members.
import { createContext, useContext, type ReactNode } from 'react';

import type { DeskRole } from 'src/utils/lead-desk';

export const HostMenuExtras = createContext<ReactNode>(null);

export const useHostMenuExtras = (): ReactNode => useContext(HostMenuExtras);

export type HostIdentity = {
  id: string;
  role: DeskRole;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  /** Ends the session. */
  onSignOut: () => void;
  /** Re-reads the account after it changed (a rename, say). */
  refresh: () => Promise<void>;
};

export const HostIdentityContext = createContext<HostIdentity | null>(null);

export const useHostIdentity = (): HostIdentity | null => useContext(HostIdentityContext);
